/* eslint-disable */
export const CurrencyFormatter = ({ value }) => {
    // Format the value as currency
    const formattedValue = value.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD',
    });
  
    return <span>{formattedValue}</span>;
  };